import { Component } from "@angular/core"
import { NavParams, ViewController, NavController, ActionSheetController, AlertController,
         LoadingController, ModalController } from "ionic-angular"

import { EventService } from "../../services/event"
import { UserService } from "../../services/user"
import { EventPickListPage } from "./pick-list"
import { UserPickListPage } from "../users/pick-list"
import { ProfilePage } from "../profile"

@Component({
  selector: "event-detail-page",
  templateUrl: "detail.html",
})
export class EventDetailPage {

  event: any = {}
  acceptedEvent: any = null
  isLoading = true
  hideConflictsMessage = false
  hasExchangeConflicts = false
  hideActionButtons = false

  constructor(
    private navParams: NavParams,
    private viewCtrl: ViewController,
    private navCtrl: NavController,
    private alertCtrl: AlertController,
    private actionSheetCtrl: ActionSheetController,
    private loadingCtrl: LoadingController,
    private modalCtrl: ModalController
  ) {

    this.event = this.navParams.get("event")
    this.hideConflictsMessage = this.navParams.get("hideConflictsMessage")
    this.hideActionButtons = this.navParams.get("hideActionButtons")

    if (this.event) {
      this.isLoading = false
    } else {
      this.getEventFromApi()
    }
  }

  onExit() {

    this.viewCtrl.dismiss({ action: "canceled", event: this.event })
  }

  onAddressClick() {

    let link = ""
    const address = this.event.entity.address

    if (address.street)
     link = address.street.trim()

   if (address.number)
     link += ", " + address.number.trim()

   if (address.city)
     link += " " + address.city.trim()

   if (address.state)
     link += " " + address.state.trim()

    const url = "http://maps.google.com/?q=" + link

    window.open(url, "_blank")
  }

  onShowOwner() {

    this.navCtrl.push(ProfilePage, { user: this.event.createdBy })
  }

  onShowUser() {

    this.navCtrl.push(ProfilePage, { user: this.event.user })
  }

  onConfirm() {

    this.viewCtrl.dismiss({ action: "confirmed" })
  }

  onNotPossible() {

    this.actionSheetCtrl.create({
      title: "O que você deseja fazer ?",
      buttons: [
        {
          text: "Liberar",
          handler: () => {

            this.viewCtrl.dismiss({ action: "released" })
          },
        },
        {
          text: "Trocar",
          handler: () => {

            this.viewCtrl.dismiss({ action: "exchanged" })
          },
        },
        {
          text: "Cancelar",
          role: "cancel",
        },
      ],
    }).present()
  }

  onShowSuggestedEvents() {

    const loading = this.loadingCtrl.create({ content: "Por favor, aguarde..." })

    loading.onDidDismiss((months) => {

      if (!months)
        return

      let options: any = { title: "Eventos sugeridos" }

      if (!EventService.isLoggedUserEvent(this.event)) {
        months = this.removeOtherUserEventsFromMonths(months)
        options.message = "Selecione um dos eventos abaixo de acordo com a sua disponibilidade para troca"
        options.pickOne = true
        options.hideUserData = true
      }

      const modal = this.modalCtrl.create(EventPickListPage, { months, options })

      modal.onDidDismiss((selectedEvents) => {

        if (selectedEvents) {
          this.acceptedEvent = selectedEvents[0]
          this.checkExchangeConflicts()
        }
      })

      modal.present()
    })

    loading.present()

    let eventIds = []

    this.event.suggestedEvents.forEach((sugEvent) => eventIds.push(sugEvent.event))

    EventService.getEventsDetail(eventIds)
      .then((months) => loading.dismiss(months))
      .catch((error) => {

        console.log(error)

        loading.dismiss()

        this.alertCtrl.create({
          message: "Falha ao obter eventos sugeridos",
          buttons: ["Ok"]
        }).present()
      })
  }

  removeOtherUserEventsFromMonths(months) {

    months.forEach((month) => {

      let events = []

      month.events.forEach((event) => {

        if (EventService.isLoggedUserEvent(event))
          events.push(event)
      })

      month.events = events.slice()
    })

    return months.slice()
  }

  onEditAcceptedEvent() {

    this.onShowSuggestedEvents()
  }

  onShowSuggestedUsers() {

    const loading = this.loadingCtrl.create({ content: "Por favor, aguarde..." })

    loading.onDidDismiss((users) => {

      if (!users)
        return

      const options = { title: "Profissionais sugeridos" }

      this.modalCtrl.create(UserPickListPage, { users, options }).present()
    })

    loading.present()

    let userIds = []

    this.event.suggestedUsers.forEach((sugUser) => userIds.push(sugUser.user))

    UserService.getUsersDetail(userIds)
      .then((users) => loading.dismiss(users))
      .catch((error) => {

        console.log(error)

        loading.dismiss()

        this.alertCtrl.create({
          message: "Falha ao obter profissionais sugeridos",
          buttons: ["Ok"]
        }).present()
      })
  }

  onAccept() {

    this.viewCtrl.dismiss({ action: "accepted", acceptedEvent: this.acceptedEvent })
  }

  onReject() {

    let message = ""
    
    if (this.event.status == "released") {
      message = "Tem certeza que deseja rejeitar esse evento ?"
    } else if (this.event.status == "exchange_requested") {
      message = "Tem certeza que deseja rejeitar essa troca ?"
    }

    this.alertCtrl.create({
      message,
      buttons: [
        {
          text: "Sim",
          handler: () => {

            this.viewCtrl.dismiss({ action: "rejected" })
          },
        },
        {
          text: "Não",
          role: "cancel",
        }
      ]
    }).present()    
  }

  onCancelReleaseOrExchange() {

    let message = ""

    if (this.event.status == "released") {
      message = "Tem certeza que deseja cancelar a liberação desse evento ?"
    } else if (this.event.status == "exchange_requested") {
      message = "Tem certeza que deseja cancelar a solicitação de troca desse evento ?"
    }

    this.alertCtrl.create({
      message,
      buttons: [
        {
          text: "Sim",
          handler: () => this.cancelReleaseOrExchange(),
        },
        {
          text: "Não",
          role: "cancel",
        }
      ]
    }).present()
  }

  cancelReleaseOrExchange() {

    const loading = this.loadingCtrl.create({ content: "Por favor, aguarde..." })

    loading.onDidDismiss((data) => {

      if (data && data.canceled)
        this.getEventFromApi()
    })

    loading.present()

    EventService.cancelReleaseOrExchange(this.event)
      .then((event) => {

        this.event = event

        loading.dismiss({ canceled: true })
      })
      .catch((error) => {

        console.log(error.response)

        loading.dismiss()

        this.alertCtrl.create({
          message: "Falha ao processar cancelamento",
          buttons: ["Ok"]
        }).present()
      })
  }

  fullAddress() {

    let fullAddress = ""
    const address = this.event.entity.address

    fullAddress = this.concatAddress(fullAddress, address.street)
    fullAddress = this.concatAddress(fullAddress, address.number, ", ")
    fullAddress = this.concatAddress(fullAddress, address.complement, " - ")
    fullAddress = this.concatAddress(fullAddress, address.district, " - ")
    fullAddress = this.concatAddress(fullAddress, address.city, " - ")
    fullAddress = this.concatAddress(fullAddress, address.state, " / ")

    if (!fullAddress)
      fullAddress = "Endereço não informado"

    return fullAddress
  }

  concatAddress(address, value, separator?) {

    if (address && value && separator)
      address += separator

    if (value)
      address += value.trim()

    return address
  }

  weekDay() {

    let weekDay = this.event.weekDay
    const startAt = this.event.startAt

    if (startAt.toLowerCase() == "hoje" || startAt.toLowerCase() == "amanhã")
      weekDay = startAt

    return weekDay
  }

  getEventFromApi() {

    const loading = this.loadingCtrl.create({ content: "Por favor, aguarde..." })

    loading.present()

    const eventId = this.navParams.get("eventId")

    EventService.getEventDetail(eventId)
      .then((event) => {

        this.event = event
        this.isLoading = false

        loading.dismiss()
      })
      .catch((error) => {

        console.log(error)

        loading.dismiss()

        this.alertCtrl.create({
          message: "Falha ao obter dados do evento",
          buttons: ["Ok"]
        }).present()
      })
  }

  isReleasedOrExchanged() {

    return (this.event.status == "released" || this.event.status == "exchange_requested")
  }

  isReleasedOrExchangedByLoggedUser() {

    return (EventService.isLoggedUserEvent(this.event) && this.isReleasedOrExchanged())
  }

  isReleasedOrExchangedByOtherUser() {

    return (this.isReleasedOrExchanged() && !EventService.isLoggedUserEvent(this.event))
  }

  showViewSuggestedEventsButton() {

    return (this.event.status == "exchange_requested" && !this.acceptedEvent)
  }

  showViewSuggestedUsersButton() {

    return (this.event.status == "released" && EventService.isLoggedUserEvent(this.event))
  }

  showEditAcceptedEventButton() {

    return (this.event.status == "exchange_requested" && this.acceptedEvent)
  }

  showConfirmButton() {

    if (this.hideActionButtons)
      return false

    return (this.event.status == "waiting_confirmation" && EventService.isLoggedUserEvent(this.event) && this.event.canConfirm)
  }

  showNotPossibleButton() {

    if (this.hideActionButtons)
      return false

    return (EventService.isLoggedUserEvent(this.event) && (this.event.status == "waiting_confirmation" || this.event.status == "confirmed"))
  }

  showAcceptButton() {

    if (this.hideActionButtons || EventService.isLoggedUserEvent(this.event) || this.hasExchangeConflicts)
      return false

    return ((this.event.status == "released" && !this.event.hasConflicts) || (this.event.status == "exchange_requested" && this.acceptedEvent))
  }

  showRejectButton() {

    if (this.hideActionButtons || EventService.isLoggedUserEvent(this.event))
      return false

    return this.isReleasedOrExchanged()
  }

  showCancelReleaseButton() {

    if (this.hideActionButtons)
      return false

    return (this.event.status == "released" && EventService.isLoggedUserEvent(this.event))
  }

  showCancelExchangeButton() {

    if (this.hideActionButtons)
      return false

    return (this.event.status == "exchange_requested" && EventService.isLoggedUserEvent(this.event))
  }

  showConflictsMessage() {

    if (!this.event.hasConflicts || this.hideConflictsMessage)
      return false

    let showMessage = true

    if (!EventService.isLoggedUserEvent(this.event) && this.event.status == "exchange_requested")
      showMessage = false

    if (this.hasExchangeConflicts)
        showMessage = true

    return showMessage
  }

  conflictMessage() {

    if (this.hasExchangeConflicts) {

      return `Essa troca não pode ser realizada porque você ou ${this.event.user.firstName} ficarão com conflito de horário com outros eventos`

    } else if (this.event.status == "waiting_confirmation" && !this.event.canConfirm) {

      return "Você não pode confirmar esse evento porque já possui um evento confirmado nessa data e horário"

    } else if ((this.event.status == "released" || this.event.status == "exchange_requested") && !EventService.isLoggedUserEvent(this.event) && this.event.hasConflicts) {

      return "Você não pode assumir esse evento porque já possui um ou mais eventos que conflitam com essa data e horário"

    } else {

      return "Você possui um ou mais eventos que conflitam com a data e horário desse evento"
    }
  }

  checkExchangeConflicts() {

    this.hasExchangeConflicts = false

    const loading = this.loadingCtrl.create({ content: "Verificando conflitos..." })

    loading.onDidDismiss((data) => {

      if (data && data.hasConflicts)
        this.hasExchangeConflicts = true
    })

    loading.present()

    EventService.validEventExchange({ event: this.event, acceptedEvent: this.acceptedEvent })
      .then((response) => loading.dismiss(response.data))
      .catch((error) => {

        loading.dismiss()

        this.acceptedEvent = null

        this.alertCtrl.create({
          message: "Falha ao verificar conflitos da troca",
          buttons: ["Ok"]
        }).present()
      })

  }
}



// WEBPACK FOOTER //
// ./src/pages/events/detail.ts